export const DOMAIN = "https://urecacoupon.store";
//export const DOMAIN = "http://localhost:8080";
export const API_DOMAIN = `${DOMAIN}/api/v1`;